<template>
  <div :class="['navbar bg_black', productCenter ? 'bg_white' : '']" ref="globalNavBar">
    <div class="inner">
      <a href="/" class="navbar-header navbar-logo">
        <i :class="['logo', productCenter ? 'logo_back' : '']"></i>
      </a>

      <div class="nav-collapse">
        <div class="nav-right" :class="[productCenter ? 'hidden' : '']">
          <router-link class="nav-item" to="/">首页</router-link>
          <router-link class="nav-item" to="/invoice">电子发票</router-link>
          <router-link class="nav-item" to="/open">开放平台</router-link>
          <a class="nav-item" target='_blank' href="https://eac.goldentec.com">高灯云企</a>
        </div>
        <div class="login-bar">
          <a class="login-btn" :href="`${SSOLoginUrl}`">登录</a>
          <a class="login-btn btn-register" :href="`${SSORegisterUrl}`">注册</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'


export default {
  name: 'PageHeader',
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
  },
  data() {
    // 统一认证中心域名
    const urls = {
      LOCAL: 'https://sso-dev.gc365.com',
      DEV: 'https://sso-dev.gc365.com',
      TEST: 'https://sso-test.gc365.com',
      PREPROD: 'https://sso-uat.gc365.com',
      PROD: 'https://sso.gc365.com'
    }
    // 登录后回跳地址，写死为高灯云控制台首页
    const consoleUrls = {
      LOCAL: 'https://console-dev.gc365.com',
      DEV: 'https://console-dev.gc365.com',
      TEST: 'https://console-test.gc365.com',
      PREPROD: 'https://console-uat.gc365.com',
      PROD: 'https://console.gc365.com'
    }

    const redirectUrl = `${RUN_ENV === 'LOCAL' ? consoleUrls[RUN_ENV] : consoleUrls[APP_ENV]}`
    // 请勿修改：appid:业务系统标识， 1000 高灯云官网，1001 高灯云控制台，1002 GC365平台, 1003 智税云 ，这里写死为1000
    const param = { redirectUrl, appid: '1000' }

    const loginUrl = `${RUN_ENV === 'LOCAL' ? urls[RUN_ENV] : urls[APP_ENV]}/login`
    const registerUrl = `${RUN_ENV === 'LOCAL' ? urls[RUN_ENV] : urls[APP_ENV]}/register`

    return {
      url: RUN_ENV === 'LOCAL' ? urls[RUN_ENV] : urls[APP_ENV],
      // 跳转到sso统一认证中心携带参数需用qs转换，请不要直接拼接参数且使用encodeURIComponent
      SSOLoginUrl: `${loginUrl}?${qs.stringify(param)}`,
      SSORegisterUrl: `${registerUrl}?${qs.stringify(param)}`,
      productCenter: false
    }
  },
  watch: {
    $route: {
      handler(val) {
        const urlArr = val.path.split('/')
        if (urlArr.indexOf('product') > -1) {
          this.productCenter = true
        } else {
          this.productCenter = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // PC端滚动条滚动特效
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    // 移除滚动事件
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      const top = document.documentElement.scrollTop
      const className = 'fixed'

      // 当top > 0 时顶导航固定在上面
      if (top > 100) {
        this.$refs.globalNavBar.classList.add(className)
      } else {
        this.$refs.globalNavBar.classList.remove(className)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.navbar {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 99;
  height: $navbarHeight;
}
.bg_black {
  background-color: transparent;

}
.bg_white {
  // 进入开放平台-产品中心样式
  background: #FFFFFF!important;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
}
.hidden {
  // 进入开放平台-产品中心时，隐藏顶部导航按钮
  visibility: hidden;
}

.navbar > .inner {
  height: $navbarHeight;
  min-width: 1200px;
  margin: 0 32px;
  @include clearfix;
}

.navbar-header {
  float: left;
}

.navbar-logo {
  height: $navbarHeight;
  @include flexBox;
  .logo {
    display:inline-block;
    width: 131px;
    height: 28px;
    margin-right: 50px;
    background: url("../assets/logo_w.png") center center no-repeat;
    background-size: cover;
  }
  .logo_back {
    // 进入开放平台-产品中心样式
    width: 208px;
    height: 30px;
    background: url("../assets/logo_w.svg") center center no-repeat;
  }
}


.nav-collapse {
  height: $navbarHeight;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    height: $navbarHeight;
    color: #FFFFFF;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
  }
  .nav-right {
    display: flex;
    /deep/.router-link-exact-active{
      color: $color-primary;
      position: relative;
      &:after{
        display: block;
        content: '';
        width: 50%;
        height: 4px;
        background-color: $color-primary;
        position: absolute;
        left: 25%;
        bottom: 0;
      }

    }
  }
  .nav-item {
    padding: 20px 10px;
    margin: 0 34px;
    &:hover{
      color: $color-primary;
    }
  }
}

.login-bar {
  .login-btn{
    color: #1B252E;
    padding: 8px 29px;

    &.btn-register{
      color: #FFFFFF;
      background: $color-primary;
      margin-left: 2px;
      border-radius: 2px;
    }

  }
  // .login-btn:nth-of-type(1){
    // margin-left: 60px;
  // }
  .line{
    display: inline-block;
    vertical-align: middle;
    color: rgba(227,227,227,1);
    padding: 0 18px;
    width:1px;
    height:16px;
    opacity:0.29;
  }
}


.bg_black.fixed {
  background-color: #FFFFFF;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.05);
  transition: background-color 1s;
  position: fixed;
  .navbar-logo .logo{
    background: url("../assets/logo_b.png") center center no-repeat;
    background-size:cover;
  }

  .nav-collapse{
    a {color: #1B252E;}
    .nav-item {
      &:hover{
        color: $color-primary;
      }
    }
  }

  .login-bar{
    .login-btn.btn-register{
      color: #FFFFFF;
    }
  }
}


</style>
